<div class="card">
  <div class="card-body">
    <h5>Sua conta gov.br é <strong>nível bronze!</strong></h5>
    <div class="card-text">
        <p>É necessário possuir conta gov.br <strong>nível ouro ou prata</strong> para utilizar a assinatura eletrônica avançada gov.br.</p>
        <p><a href="http://confiabilidades.acesso.gov.br/"  target="_blank">Clique aqui</a> para aumentar o nível da sua conta, e realize um novo acesso através do link enviado por e-mail.</p>
    </div>
  </div>
</div>
